import type { BusinessProfileInput } from '@mybusinessmate/schema';

export type Industry = BusinessProfileInput['industry'];

/** Short names for the Settings category select (onboarding uses longer, descriptive labels). */
export const INDUSTRY_LABEL: Record<Industry, string> = {
  restaurant: 'Restaurant',
  retail: 'Retail',
  local_services: 'Local services',
  healthcare: 'Healthcare',
  education: 'Education',
  real_estate: 'Real estate',
  other: 'Other',
};

export const INDUSTRY_OPTIONS = Object.entries(INDUSTRY_LABEL) as [Industry, string][];
